<div class="flex flex-row flex-wrap justify-start items-center content-center">
    <mat-form-field class="w-full" [appearance]="apparience">
        <mat-label>{{label}}</mat-label>
        <mat-chip-grid #chipList>
            <mat-chip-row *ngFor="let et of etiquetas" [removable]="removable"
                (removed)="remove(et.slug)">
                {{et.slug}}
                <span *ngIf="et.nueva" class="label-new" matTooltip="Se creará al guardar">nueva</span>
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip-row>
            <input
                [placeholder]="allowCreate ? 'Agregar etiqueta (busca o crea una nueva)' : 'Agregar etiqueta'"
                autocomplete="off" #labelInput [formControl]="labelForm"
                [matAutocomplete]="autoLabel" [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)"
                (click)="openList()"
            >
        </mat-chip-grid>
        <mat-autocomplete
            #autoLabel="matAutocomplete"
            autoActiveFirstOption
            (optionSelected)="selected($event)"
            position="below">
            <mat-option *ngFor="let option of filteredLabels | async" [value]="option"
                [disabled]="option.kind === 'info'"
                [class.label-option--create]="option.kind === 'create'">

                <ng-container [ngSwitch]="option.kind">
                    <ng-container *ngSwitchCase="'create'">
                        <mat-icon class="label-option__icon">add</mat-icon>
                        Crear etiqueta «{{ option.slug }}»
                        <span *ngIf="option.similar?.length" class="label-option__warning">
                            · hay {{ option.similar.length === 1 ? '1 parecida' : option.similar.length + ' parecidas' }}
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'similar'">
                        {{ option.slug }} <span class="label-option__hint">¿quisiste decir?</span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'info'">
                        <span class="label-option__hint">{{ option.slug }}</span>
                    </ng-container>
                    <ng-container *ngSwitchDefault>{{ option.slug }}</ng-container>
                </ng-container>
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
</div>
